import { useTracksSearchResult } from "frontend/src/domain/tracks";
import { usePagination } from "frontend/src/lib/pagination";
import { useCheckTracks } from "./use-check-tracks";
import { useSearchTrackForm } from "./use-search-track-form";
import { useTableSort } from "./use-table-sort";
export var usePage = function () {
    var _a;
    var _b = useSearchTrackForm(), search = _b.search, genres = _b.genres;
    var _c = usePagination({
        page: 0,
        rowsPerPage: 25,
        pageResetDeps: [search.debouncedValue, genres.checkedIds],
    }), page = _c.page, rowsPerPage = _c.rowsPerPage, skip = _c.skip, onChangeRowsPerPage = _c.onChangeRowsPerPage, onChangePage = _c.onChangePage;
    var _d = useTableSort(), onSort = _d.onSort, sortBy = _d.sortBy, orderBy = _d.orderBy;
    var data = useTracksSearchResult({
        params: {
            genres: genres.checkedIds,
            search: search.debouncedValue,
            offset: skip,
            limit: rowsPerPage,
            sortBy: sortBy,
            orderBy: orderBy,
        },
    }).data;
    var _e = useCheckTracks(data === null || data === void 0 ? void 0 : data.tracks), checked = _e.checked, unCheckAll = _e.unCheckAll, tracks = _e.tracks, toggleById = _e.toggleById, publish = _e.publish, unpublish = _e.unpublish, play = _e.play, resume = _e.resume, pause = _e.pause, removeChecked = _e.removeChecked, refreshDurations = _e.refreshDurations, isRefreshingDurations = _e.isRefreshingDurations;
    return {
        pagination: { page: page, rowsPerPage: rowsPerPage, onChangeRowsPerPage: onChangeRowsPerPage, onChangePage: onChangePage },
        search: {
            value: search.value,
            onChange: search.onChange,
            genres: genres,
        },
        tracks: {
            onToggle: toggleById,
            entries: tracks,
            total: (_a = data === null || data === void 0 ? void 0 : data.total) !== null && _a !== void 0 ? _a : 0,
            publish: publish,
            unpublish: unpublish,
            checked: checked,
            unCheckAll: unCheckAll,
            removeChecked: removeChecked,
            refreshDurations: refreshDurations,
            isRefreshingDurations: isRefreshingDurations,
            onPlay: play,
            onResume: resume,
            onPause: pause,
        },
        sorting: { onChange: onSort, sortBy: sortBy, orderBy: orderBy },
    };
};
